/* LUNÉA SHAVE™ — Theme JS | Export aus lunea-theme */
(function() {
  "use strict";
  var $ = function(s, r) {
      return (r || document).querySelector(s)
    },
    $$ = function(s, r) {
      return Array.prototype.slice.call((r || document).querySelectorAll(s))
    },
    menuToggle = $("[data-menu-toggle]"),
    mobileNav = $("[data-mobile-nav]");
  menuToggle && mobileNav && menuToggle.addEventListener("click", function() {
    var open = mobileNav.classList.toggle("open");
    menuToggle.setAttribute("aria-expanded", open ? "true" : "false")
  });
  var drawer = $("[data-cart-drawer]"),
    overlay = $("[data-drawer-overlay]"),
    lastFocus = null;

  function openDrawer() {
    if (drawer) {
      lastFocus = document.activeElement, drawer.classList.add("open"), overlay && overlay.classList.add("open"), drawer.setAttribute("aria-hidden", "false"), document.body.style.overflow = "hidden";
      var close = $("[data-drawer-close]", drawer);
      close && close.focus()
    }
  }

  function closeDrawer() {
    drawer && (drawer.classList.remove("open"), overlay && overlay.classList.remove("open"), drawer.setAttribute("aria-hidden", "true"), document.body.style.overflow = "", lastFocus && lastFocus.focus && lastFocus.focus())
  }

  function closeLightbox() {
    var lb = $("[data-lightbox]");
    lb && (lb.classList.remove("open"), document.body.style.overflow = "")
  }
  document.addEventListener("click", function(e) {
    (e.target.closest("[data-drawer-close]") || e.target.closest("[data-drawer-overlay]")) && (e.preventDefault(), closeDrawer());
    var openBtn = e.target.closest("[data-cart-open]");
    openBtn && drawer && (e.preventDefault(), refreshCart().then(openDrawer))
  }), document.addEventListener("keydown", function(e) {
    e.key === "Escape" && (closeDrawer(), closeLightbox())
  });

  function drawerInnerHtml(html) {
    var doc = new DOMParser().parseFromString(html, "text/html"),
      inner = doc.querySelector("[data-cart-drawer-inner]");
    if (inner) return inner.innerHTML;
    var section = doc.getElementById("shopify-section-cart-drawer");
    if (section) {
      var nested = section.querySelector("[data-cart-drawer-inner]");
      if (nested) return nested.innerHTML
    }
    return null
  }

  function applyCartSections(data) {
    if (!(!data || !data.sections)) {
      var target = $("[data-cart-drawer-inner]"),
        raw = data.sections["cart-drawer"];
      if (target && raw) {
        var inner = drawerInnerHtml(raw);
        inner !== null && (target.innerHTML = inner)
      }
      updateCartCount()
    }
  }

  function updateCartCount() {
    fetch("/cart.js", {
      headers: {
        Accept: "application/json"
      }
    }).then(function(r) {
      return r.json()
    }).then(function(cart) {
      $$("[data-cart-count]").forEach(function(el) {
        el.textContent = cart.item_count, el.style.display = cart.item_count > 0 ? "" : "none"
      })
    }).catch(function() {})
  }

  function refreshCart() {
    return fetch("?sections=cart-drawer", {
      headers: {
        Accept: "application/json"
      }
    }).then(function(r) {
      return r.json()
    }).then(function(data) {
      applyCartSections({
        sections: data
      })
    }).catch(function() {})
  }

  function addToCart(formData, button) {
    return button && button.setAttribute("data-loading", "true"), formData.append("sections", "cart-drawer"), fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json"
      }
    }).then(function(r) {
      return r.json().then(function(b) {
        return {
          ok: r.ok,
          body: b
        }
      })
    }).then(function(res) {
      if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : "Fehler");
      applyCartSections(res.body), openDrawer()
    }).catch(function(err) {
      var msg = $("[data-form-error]");
      msg && (msg.textContent = err.message || "Das hat leider nicht geklappt. Bitte versuche es erneut.", msg.hidden = !1)
    }).then(function() {
      button && button.removeAttribute("data-loading")
    })
  }
  document.addEventListener("submit", function(e) {
    var form2 = e.target.closest('form[action*="/cart/add"]');
    if (!(!form2 || !drawer)) {
      e.preventDefault();
      var btn = form2.querySelector('[type="submit"]'),
        err = $("[data-form-error]");
      err && (err.hidden = !0), addToCart(new FormData(form2), btn)
    }
  }), document.addEventListener("click", function(e) {
    var btn = e.target.closest("[data-line-change]");
    if (btn) {
      e.preventDefault();
      var line = btn.getAttribute("data-line"),
        qty = parseInt(btn.getAttribute("data-line-change"), 10);
      btn.disabled = !0, fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          line: parseInt(line, 10),
          quantity: qty,
          sections: "cart-drawer"
        })
      }).then(function(r) {
        return r.json()
      }).then(function(body) {
        applyCartSections(body)
      }).catch(function() {
        window.location.href = "/cart"
      })
    }
  }), document.addEventListener("click", function(e) {
    var btn = e.target.closest("[data-qty-step]");
    if (btn) {
      var input = btn.parentElement.querySelector("input");
      if (input) {
        var floor = parseInt(input.getAttribute("min"), 10);
        isNaN(floor) && (floor = 1);
        var next = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute("data-qty-step"), 10);
        input.value = Math.max(floor, next), input.dispatchEvent(new Event("change", {
          bubbles: !0
        }))
      }
    }
  });
  var track = $("[data-gal-track]");
  if (track) {
    var slides = $$(".gal-slide", track),
      thumbs = $$("[data-gal-thumb]"),
      dots = $$("[data-gal-dot]"),
      markActive = function(i) {
        thumbs.forEach(function(t, n) {
          t.setAttribute("aria-current", n === i ? "true" : "false")
        }), dots.forEach(function(d, n) {
          d.setAttribute("aria-current", n === i ? "true" : "false")
        })
      },
      goTo = function(i) {
        slides[i] && (track.scrollTo({
          left: slides[i].offsetLeft - track.offsetLeft,
          behavior: "smooth"
        }), markActive(i))
      };
    thumbs.forEach(function(t, i) {
      t.addEventListener("click", function() {
        goTo(i)
      })
    }), dots.forEach(function(d, i) {
      d.addEventListener("click", function() {
        goTo(i)
      })
    });
    var raf;
    track.addEventListener("scroll", function() {
      cancelAnimationFrame(raf), raf = requestAnimationFrame(function() {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        markActive(Math.min(Math.max(i, 0), slides.length - 1))
      })
    }), window.luneaGalleryGoTo = goTo
  }
  var lightbox = $("[data-lightbox]"),
    lightboxImg = lightbox ? $("img", lightbox) : null;

  function openLightbox(src, alt) {
    if (!(!lightbox || !lightboxImg)) {
      lightboxImg.src = src, lightboxImg.alt = alt || "", lightbox.classList.add("open"), document.body.style.overflow = "hidden";
      var c = $(".close", lightbox);
      c && c.focus()
    }
  }

  function zoomFromSlide(slide) {
    var img = slide.querySelector("img");
    img && openLightbox(slide.getAttribute("data-zoom") || img.src, img.alt)
  }
  document.addEventListener("click", function(e) {
    if (lightbox && (e.target.closest("[data-lightbox-close]") || e.target === lightbox)) {
      closeLightbox();
      return
    }
    var slide = e.target.closest(".gal-slide");
    slide && zoomFromSlide(slide)
  }), document.addEventListener("keydown", function(e) {
    if (!(e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar")) {
      var slide = e.target.closest ? e.target.closest(".gal-slide") : null;
      slide && (e.preventDefault(), zoomFromSlide(slide))
    }
  });
  var form = $("#ProductForm"),
    dataEl = $("[data-product-json]");
  if (form && dataEl) {
    var payload;
    try {
      payload = JSON.parse(dataEl.textContent)
    } catch (e) {
      payload = null
    }
    if (payload && payload.variants) {
      var variants = payload.variants,
        variantInput = form.querySelector("[data-variant-input]"),
        priceEl = form.querySelector("[data-price]"),
        compareEl = form.querySelector("[data-compare]"),
        addBtn = form.querySelector("[data-add-button]"),
        addText = form.querySelector("[data-add-text]"),
        defaultLabel = addText ? addText.textContent.trim() : "In den Warenkorb",
        selection = function() {
          return $$("[data-option-group]").map(function(g) {
            var active = g.querySelector('[aria-checked="true"]');
            return active ? active.getAttribute("data-value") : null
          })
        },
        match = function(sel) {
          return variants.filter(function(v) {
            return sel.every(function(val, i) {
              return val === null || v.options[i] === val
            })
          })[0]
        },
        markAvailability = function() {
          $$("[data-option-group]").forEach(function(group) {
            var idx = parseInt(group.getAttribute("data-option-group"), 10);
            $$("[data-option-value]", group).forEach(function(btn) {
              var val = btn.getAttribute("data-value"),
                any = variants.some(function(v) {
                  return v.options[idx] === val && v.available
                });
              btn.setAttribute("data-soldout", any ? "false" : "true")
            })
          })
        },
        update = function() {
          var variant = match(selection());
          if (!variant) {
            addBtn && (addBtn.disabled = !0), addText && (addText.textContent = "Nicht verf\xFCgbar");
            return
          }
          variantInput && (variantInput.value = variant.id), priceEl && (priceEl.innerHTML = variant.price), compareEl && (variant.compare ? (compareEl.innerHTML = variant.compare, compareEl.hidden = !1) : compareEl.hidden = !0), addBtn && addText && (addBtn.disabled = !variant.available, addText.textContent = variant.available ? defaultLabel : "Ausverkauft");
          var sPrice = $("[data-sticky-price]");
          sPrice && (sPrice.innerHTML = variant.price);
          var sBtn = $("[data-sticky-button]");
          if (sBtn && (sBtn.disabled = !variant.available, sBtn.textContent = variant.available ? defaultLabel : "Ausverkauft"), typeof variant.imageIndex == "number" && variant.imageIndex >= 0 && window.luneaGalleryGoTo && window.luneaGalleryGoTo(variant.imageIndex), window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set("variant", variant.id), window.history.replaceState({}, "", url.toString())
          }
        };
      $$("[data-option-value]").forEach(function(btn) {
        btn.addEventListener("click", function() {
          var group = btn.closest("[data-option-group]");
          group && $$("[data-option-value]", group).forEach(function(b) {
            b.setAttribute("aria-checked", "false"), b.setAttribute("tabindex", "-1")
          }), btn.setAttribute("aria-checked", "true"), btn.setAttribute("tabindex", "0");
          var idx = btn.getAttribute("data-option-index"),
            label = $('[data-option-label="' + idx + '"]');
          label && (label.textContent = btn.getAttribute("data-value")), update()
        }), btn.addEventListener("keydown", function(e) {
          if (!(e.key !== "ArrowRight" && e.key !== "ArrowLeft")) {
            e.preventDefault();
            var group = btn.closest("[data-option-group]");
            if (group) {
              var items = $$("[data-option-value]", group),
                i = items.indexOf(btn),
                next = items[(i + (e.key === "ArrowRight" ? 1 : items.length - 1)) % items.length];
              next && (next.focus(), next.click())
            }
          }
        })
      }), markAvailability(), update()
    }
  }
  var sticky = $("[data-sticky-atc]"),
    anchor = $("[data-atc-anchor]");
  sticky && anchor && "IntersectionObserver" in window && (document.body.classList.add("has-sticky-atc"), new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      sticky.classList.toggle("show", !entry.isIntersecting && entry.boundingClientRect.top < 0)
    })
  }, {
    rootMargin: "0px 0px -100% 0px"
  }).observe(anchor));
  var stickyBtn = $("[data-sticky-button]");
  stickyBtn && form && stickyBtn.addEventListener("click", function() {
    form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event("submit", {
      cancelable: !0,
      bubbles: !0
    }))
  }), updateCartCount()
})();
//# sourceMappingURL=/s/files/1/0884/5233/3895/t/32/assets/theme.js.map